export const translations = {
  tr: {
    brandName: 'Little Friends',
    brandTagline: 'Kahve & Oyun',
    playgroundCheckIn: 'Oyun Alanı Giriş',
    playgroundSubtitle: 'Minikleriniz için denetimli oyun alanı',
    checkInKids: 'Çocuk Girişi',
    tapToStart: 'Başlamak için dokunun',
    hostDashboard: 'Personel Paneli',
    hostDashboardSub: 'Girişleri ve ziyaretleri yönetin',
    safeSupervised: 'Güvenli • Denetimli • Eğlenceli',

    checkIn: 'Giriş',
    welcome: 'Hoş Geldiniz!',
    enterPhoneToCheckIn: 'Miniklerinizi kaydetmek için telefon numaranızı girin',
    phoneNumber: 'Telefon Numarası',
    enterPhoneNumber: 'Telefon numaranızı girin',
    phoneLookupHint: 'Kayıtlı bilgilerinizi bulmak için kullanacağız',
    continue: 'Devam',
    pleaseEnterPhone: 'Lütfen telefon numaranızı girin',
    pleaseEnterValidPhone: 'Lütfen geçerli bir telefon numarası girin',
    somethingWentWrong: 'Bir şeyler yanlış gitti. Lütfen tekrar deneyin.',
    back: 'Geri',

    newRegistration: 'Yeni Kayıt',
    yourInformation: 'Bilgileriniz',
    firstName: 'Ad',
    enterFirstName: 'Adınızı girin',
    lastName: 'Soyad',
    enterLastName: 'Soyadınızı girin',
    children: 'Çocuklar',
    child: 'Çocuk',
    childName: 'Çocuğun Adı',
    enterChildName: 'Çocuğun adını girin',
    birthday: 'Doğum Tarihi',
    birthdayFormat: 'YYYY-AA-GG',
    addAnotherChild: 'Başka Çocuk Ekle',
    nameRequired: 'Ad gerekli',
    surnameRequired: 'Soyad gerekli',
    childNameRequired: 'Çocuk adı gerekli',
    birthdayRequired: 'Doğum tarihi gerekli',
    useDateFormat: 'YYYY-AA-GG formatını kullanın',
    failedToRegister: 'Kayıt başarısız. Lütfen tekrar deneyin.',
    register: 'Kaydol ve Devam Et',

    selectChildren: 'Çocuk Seçin',
    selectChildrenForToday: 'Bugün için çocukları seçin',
    selectAll: 'Tümünü Seç',
    yearsOld: 'yaşında',
    addNewChild: 'Yeni Çocuk Ekle',
    cancel: 'İptal',
    addChild: 'Çocuk Ekle',
    editInfo: 'Bilgileri Düzenle',
    editChildTitle: 'Çocuk Bilgilerini Düzenle',
    saveChanges: 'Kaydet',
    childUpdated: 'Bilgiler güncellendi',
    failedToUpdateChild: 'Bilgiler güncellenemedi',
    under24Months: '24 aydan küçük',
    under24Short: '24 ay altı',
    multipleProfilesFound: 'Bu numaraya bağlı birden fazla profil bulundu. Lütfen kendi profilinizi seçin.',
    selectYourProfile: 'Profilinizi Seçin',
    searchCountry: 'Ülke ara...',
    country: 'Ülke',
    noCountryFound: 'Ülke bulunamadı',
    invalidPhoneForCountry: 'Seçilen ülke için geçerli bir numara girin',
    paymentReminder: 'Önemli: Oyun alanına giriş onayı için lütfen ödemenizi tamamlayın.',
    noShowExit: 'Durmadı (Ödemesiz Çıkış)',
    noShowConfirmTitle: 'Ödemesiz çıkış onayı',
    noShowConfirmBody: 'Bu çocuk oyun alanında durmadı. Ödeme alınmadan çıkışı yapılacak ve giriş "Durmadı – Ödemesiz Çıkış" olarak kaydedilecek. Devam edilsin mi?',
    noShowConfirmAction: 'Ödemesiz Çıkış Yap',
    noShowDone: 'Ödemesiz çıkış yapıldı (Durmadı)',
    noShowStatus: 'Durmadı – Ödemesiz Çıkış',
    managePayment: 'Ödeme Yönetimi',
    changeAmount: 'Tutarı Değiştir',
    changeType: 'Ödeme Türünü Değiştir',
    refundFull: 'İade Et',
    awaitingApproval: 'Onay bekliyor',
    sentForApproval: 'Yönetici onayına gönderildi',
    paymentUpdated: 'Ödeme güncellendi',
    newAmount: 'Yeni tutar',
    confirmRefundTitle: 'İadeyi onayla',
    confirmRefundBody: 'Bu çocuğun ödemesi için tam iade talebi oluşturulacak. Değişiklik yönetici onayından sonra geçerli olur. Devam edilsin mi?',
    paymentApprovals: 'Ödeme Onayları',
    approve: 'Onayla',
    reject: 'Reddet',
    noPendingApprovals: 'Bekleyen onay yok',
    submitRequest: 'Talep Gönder',
    childrenSelected: 'çocuk seçildi',
    pleaseSelectChild: 'Lütfen en az bir çocuk seçin',
    failedToAddChild: 'Çocuk eklenemedi',
    failedToCheckin: 'Giriş isteği oluşturulamadı',
    startOver: 'Başa Dön',
    submitCheckin: 'Giriş İsteği Gönder',

    requestSubmitted: 'İstek Gönderildi!',
    checkinRequestReceived: 'Giriş isteğiniz alındı',
    childrenCheckingIn: 'Giriş yapan çocuklar:',
    nextSteps: 'Sonraki Adımlar',
    step1: 'Personel masasına gidin',
    step2: 'Personelle ödemeyi tamamlayın',
    step3: 'Personel girişi onaylayacak',
    step4: 'Minikleriniz oynamaya başlayabilir!',
    importantNote: 'Giriş personel tarafından onaylanana kadar lütfen çocukları gözetimsiz bırakmayın.',
    done: 'Tamam',

    hostLogin: 'Personel Girişi',
    staffAccessOnly: 'Sadece personel erişimi',
    adminLogin: 'Yönetici Girişi',
    adminAccessOnly: 'Sadece yönetici erişimi',
    username: 'Kullanıcı Adı',
    enterUsername: 'Kullanıcı adını girin',
    password: 'Şifre',
    enterPassword: 'Şifreyi girin',
    login: 'Giriş Yap',
    contactManagement: 'Erişim için yönetimle iletişime geçin',
    pleaseEnterCredentials: 'Lütfen kullanıcı adı ve şifre girin',
    invalidCredentials: 'Geçersiz kimlik bilgileri',

    dashboard: 'Panel',
    kidsInside: 'İçerideki Çocuklar',
    pending: 'Bekleyen',
    inside: 'İçeride',
    search: 'Ara',
    noPendingCheckins: 'Bekleyen Giriş Yok',
    allCaughtUp: 'Hepsi tamam!',
    noKidsInside: 'İçeride Çocuk Yok',
    playgroundEmpty: 'Oyun alanı boş',
    confirmPaymentCheckin: 'Ödeme ve Girişi Onayla',
    checkOut: 'Çıkış',
    checkOutAll: 'Tümünü Çıkar',
    checkedInAt: 'Giriş saati',
    searchByPhoneOrName: 'Telefon veya isimle ara...',
    noResults: 'Sonuç Yok',
    tryDifferentSearch: 'Farklı bir arama deneyin',
    totalVisits: 'Toplam ziyaret',
    logout: 'Çıkış Yap',
    error: 'Hata',
    failedToConfirm: 'Onaylama başarısız',
    failedToCheckout: 'Çıkış başarısız',
    searchFailed: 'Arama başarısız',
    submitted: 'Gönderildi',

    hours: 's',
    minutes: 'd',

    language: 'Dil',
    turkish: 'Türkçe',
    english: 'English',

    paymentAmount: 'Ödeme Tutarı',
    paymentType: 'Ödeme Türü',
    selectAmount: 'Tutar seçin',
    selectPaymentType: 'Ödeme türü seçin',
    cash: 'Nakit',
    card: 'Kart',
    other: 'Diğer',
    loyaltyDiscount: 'Sadakat İndirimi',
    loyalty_discount: 'Sadakat İndirimi',
    otherAmount: 'Diğer Tutar',
    removeCheckin: 'Girişi Kaldır',
    removeCheckinConfirm: 'Bu bekleyen giriş isteğini kaldırmak istediğinize emin misiniz? Bu işlem geri alınamaz.',
    remove: 'Kaldır',
    checkinRemoved: 'Bekleyen giriş kaldırıldı',
    refund: 'İade Et',
    refundPayment: 'Ödeme İadesi',
    refundAmount: 'İade Tutarı',
    refundHint: 'Kısmi iade için tutarı değiştirebilirsiniz',
    refunded: 'İade Edildi',
    paid: 'Ödendi',
    paymentRefunded: 'Ödeme iade edildi',
    invalidRefund: 'Geçerli bir tutar girin',
    totalRefunds: 'Toplam İade',
    notes: 'Notlar',
    notesPlaceholder: 'İsteğe bağlı not ekleyin...',
    monthsUnit: 'ay',
    yearsUnit: 'yaş',
    youngKidWarningTitle: 'Yaş Uyarısı',
    youngKidWarning: 'Alanımız 2–6 yaş grubu çocuklar için uygundur. 2 yaşın altındaki çocuklarımızın ebeveyn desteğiyle alanı kullanmaları gerekmektedir.',
    paymentRequired: 'Ödeme Gerekli',
    skipPayment: 'Ödemesiz Giriş',
    confirmWithPayment: 'Ödeme ile Onayla',
    collectPayment: 'Ödeme Al',
    paymentCollected: 'Ödeme Alındı',
    unpaid: 'Ödenmedi',
    tl: '₺',

    pause: 'Duraklat',
    resume: 'Devam Et',
    onBreak: 'Mola',
    paused: 'Duraklatıldı',

    statsTab: 'İstatistik',
    todaysSummary: 'Günün Özeti',
    summary: 'Özet',
    showingStatsFor: 'Gösterilen tarih',
    today: 'Bugün',
    duration: 'Süre',
    childrenDetails: 'Çocuk Detayları',
    totalCheckins: 'Toplam Giriş',
    totalCheckouts: 'Toplam Çıkış',
    totalRevenue: 'Toplam Gelir',
    unpaidVisits: 'Ödenmemiş',
    avgDuration: 'Ort. Süre',
    paymentBreakdown: 'Ödeme Dağılımı',
    otherPayment: 'Diğer',
    todaysChildren: 'Bugünkü Çocuklar',
    statusActive: 'İçeride',
    statusCheckedOut: 'Çıkış Yaptı',
    statusPending: 'Bekliyor',
    statusPaused: 'Molada',
    noVisitsToday: 'Bugün henüz ziyaret yok',
    min: 'dk',

    kioskQR: 'Kiosk QR Kodu',
    qrTitle: 'Oyun Alanına Hoş Geldiniz!',
    qrInstruction: 'Giriş yapmak için QR kodu telefonunuzla tarayın',
    qrStep1: 'Telefonunuzun kamerasını açın',
    qrStep2: 'QR kodu tarayın',
    qrStep3: 'Çocuklarınızı kaydedin',
    qrPoweredBy: 'Little Friends Coffee & Play',

    admin: 'Yönetici',
    adminDashboard: 'Yönetici Paneli',
    adminSubtitle: 'İşletme istatistikleri ve pazarlama',
    backToHost: 'Panele Dön',
    overview: 'Genel Bakış',
    bookkeeping: 'Muhasebe',
    birthdays: 'Doğum Günleri',
    daily: 'Günlük',
    weekly: 'Haftalık',
    monthly: 'Aylık',
    checkinsMetric: 'Girişler',
    childrenMetric: 'Çocuk Sayısı',
    revenueMetric: 'Gelir',
    avgTransaction: 'Ort. İşlem',
    transactionsMetric: 'İşlem Sayısı',
    downloadCsv: 'CSV İndir',
    bookkeepingCsv: 'Muhasebe CSV',
    bookkeepingDesc: 'Ziyaret ve ödeme kayıtlarını dönem bazında indirin.',
    customRange: 'Özel Tarih Aralığı',
    startDate: 'Başlangıç',
    endDate: 'Bitiş',
    downloadRange: 'Aralığı İndir (CSV)',
    selectDates: 'Lütfen başlangıç ve bitiş tarihi seçin',
    apply: 'Göster',
    exportBirthdayList: 'Doğum Günü Listesini İndir (CSV)',
    thisMonth: 'Bu Ay',
    nextMonth: 'Gelecek Ay',
    next30: 'Sonraki 30 Gün',
    next60: 'Sonraki 60 Gün',
    allBirthdays: 'Tümü',
    deleteEvent: 'Etkinliği Sil',
    deleteEventConfirm: 'Bu etkinlik kalıcı olarak silinecek. Hem Liste hem de Takvim görünümünden kaldırılacak. Devam edilsin mi?',
    eventDeleted: 'Etkinlik silindi',
    selectMonth: 'Ay Seç',
    childFirstName: 'Çocuk Adı',
    birthday: 'Doğum Günü',
    turningAge: 'Dolduracağı Yaş',
    guardianName: 'Veli Adı',
    email: 'E-posta',
    phone: 'Telefon',
    lastVisit: 'Son Ziyaret',
    lastVisitRange: 'Son Ziyaret Tarihi',
    clearRange: 'Temizle',
    readFullText: 'Metnin tamamını oku',
    consentTitle: 'Onaylar',
    consentOptionalHint: 'Bu onaylar isteğe bağlıdır. Onay vermeseniz de çocuğunuzun girişini tamamlayabilirsiniz.',
    colMarketingConsent: 'Pazarlama Verisi Onayı',
    colMarketingConsentDate: 'Pazarlama Onay Tarihi',
    colCommConsent: 'Ticari İleti Onayı',
    colCommConsentDate: 'Ticari İleti Onay Tarihi',
    consentYes: 'Evet',
    consentNo: 'Hayır',
    consentNotCollected: 'Toplanmadı',
    eligibleOnly: 'Yalnızca Pazarlama İzinli',
    events: 'Etkinlikler',
    eventsList: 'Liste',
    eventsCalendar: 'Takvim',
    status: 'Durum',
    allStatuses: 'Tüm Durumlar',
    sortBy: 'Sırala',
    sortSubmission: 'Başvuru Tarihi',
    sortRequestedDate: 'İstenen Tarih',
    requests: 'talep',
    noEvents: 'Henüz etkinlik talebi yok',
    parentName: 'Veli Adı',
    kids: 'Çocuk',
    adults: 'Yetişkin',
    priceTL: 'Fiyat (TL)',
    priceNotSet: 'Fiyat girilmedi',
    statusNew: 'Yeni',
    statusOfferSent: 'Teklif Gönderildi',
    statusConfirmed: 'Onaylandı',
    statusCompleted: 'Tamamlandı',
    statusCancelled: 'İptal Edildi',
    calendarHint: 'Onaylanmış rezervasyonlar anlaşılan tarihte gösterilir. Detaylar için tıklayın.',
    mon: 'Pzt', tue: 'Sal', wed: 'Çar', thu: 'Per', fri: 'Cum', sat: 'Cmt', sun: 'Paz',
    originalDate: 'İstenen Tarih',
    originalTime: 'İstenen Saat',
    submittedOn: 'Başvuru Tarihi',
    agreedDate: 'Anlaşılan Tarih',
    agreedTime: 'Anlaşılan Saat',
    depositReceived: 'Kapora Alındı',
    depositAmount: 'Kapora Tutarı (TL)',
    internalNotes: 'Dahili Notlar',
    saveChanges: 'Değişiklikleri Kaydet',
    savedSuccessfully: 'Kaydedildi',
    childAge: 'Çocuğun Yaşı',
    requestedDate: 'İstenen Tarih',
    selectTime: 'Saat seçin',
    birthdayTitle: "Little Friends'te Doğum Gününü Kutla!",
    birthdaySubtitle: 'Özel bir doğum günü mü planlıyorsunuz? Tercih ettiğiniz tarihi ve parti detaylarını paylaşın, ekibimiz uygunluk ve düzenlemeleri görüşmek için sizinle iletişime geçsin.',
    parentInfo: 'Veli Bilgileri',
    childInfo: 'Çocuk Bilgileri',
    conceptBreakfast: 'Doğum Günü Kahvaltısı',
    conceptTea: 'Beş Çayı',
    addEvent: '+ Etkinlik Ekle',
    createEvent: 'Etkinlik Oluştur',
    partyDetails: 'Parti Detayları',
    preferredTime: 'Tercih Edilen Saat',
    altDate: 'Alternatif Tarih',
    altTime: 'Alternatif Saat',
    estChildren: 'Tahmini Çocuk Sayısı',
    estAdults: 'Tahmini Yetişkin Sayısı',
    specialRequests: 'Özel İstekler / Ek Notlar',
    sendBirthdayRequest: 'Doğum Günü Talebi Gönder',
    fillRequiredFields: 'Lütfen zorunlu alanları doldurun',
    dateCannotBePast: 'Tarih geçmişte olamaz',
    thankYou: 'Teşekkürler!',
    birthdaySuccessMsg: 'Doğum günü talebinizi aldık. Ekibimiz detaylarınızı inceleyip uygunluk ve düzenlemeleri görüşmek için kısa süre içinde sizinle iletişime geçecek.',
    submitAnother: 'Yeni Talep Gönder',
    noBirthdays: 'Bu dönemde doğum günü yok',
    emailNotCollected: 'E-posta adresi şu anda toplanmıyor. Pazarlama ve ticari ileti onayları giriş sırasında kaydedilmektedir.',
    january: 'Ocak', february: 'Şubat', march: 'Mart', april: 'Nisan',
    may: 'Mayıs', june: 'Haziran', july: 'Temmuz', august: 'Ağustos',
    september: 'Eylül', october: 'Ekim', november: 'Kasım', december: 'Aralık',
  },
  en: {
    brandName: 'Little Friends',
    brandTagline: 'Coffee & Play',
    playgroundCheckIn: 'Playground Check-In',
    playgroundSubtitle: 'A supervised play space for your little ones',
    checkInKids: 'Check In Kids',
    tapToStart: 'Tap here to get started',
    hostDashboard: 'Host Dashboard',
    hostDashboardSub: 'Manage check-ins and visits',
    safeSupervised: 'Safe • Supervised • Fun',

    checkIn: 'Check In',
    welcome: 'Welcome!',
    enterPhoneToCheckIn: 'Enter your phone number to check in your little ones',
    phoneNumber: 'Phone Number',
    enterPhoneNumber: 'Enter your phone number',
    phoneLookupHint: 'We will use this to look up your saved information',
    continue: 'Continue',
    pleaseEnterPhone: 'Please enter your phone number',
    pleaseEnterValidPhone: 'Please enter a valid phone number',
    somethingWentWrong: 'Something went wrong. Please try again.',
    back: 'Back',

    newRegistration: 'New Registration',
    yourInformation: 'Your Information',
    firstName: 'First Name',
    enterFirstName: 'Enter your first name',
    lastName: 'Last Name',
    enterLastName: 'Enter your last name',
    children: 'Children',
    child: 'Child',
    childName: "Child's Name",
    enterChildName: "Enter child's name",
    birthday: 'Birthday',
    birthdayFormat: 'YYYY-MM-DD',
    addAnotherChild: 'Add Another Child',
    nameRequired: 'Name is required',
    surnameRequired: 'Surname is required',
    childNameRequired: 'Child name is required',
    birthdayRequired: 'Birthday is required',
    useDateFormat: 'Use format YYYY-MM-DD',
    failedToRegister: 'Failed to register. Please try again.',
    register: 'Register & Continue',

    selectChildren: 'Select Children',
    selectChildrenForToday: 'Select children for today',
    selectAll: 'Select All',
    yearsOld: 'years old',
    addNewChild: 'Add New Child',
    cancel: 'Cancel',
    addChild: 'Add Child',
    editInfo: 'Edit Information',
    editChildTitle: 'Edit Child Information',
    saveChanges: 'Save',
    childUpdated: 'Information updated',
    failedToUpdateChild: 'Could not update information',
    under24Months: 'Under 24 months',
    under24Short: 'Under 24mo',
    multipleProfilesFound: 'Multiple profiles are linked to this number. Please select your profile.',
    selectYourProfile: 'Select Your Profile',
    searchCountry: 'Search country...',
    country: 'Country',
    noCountryFound: 'No country found',
    invalidPhoneForCountry: 'Enter a valid number for the selected country',
    paymentReminder: 'Important: Please complete your payment to receive approval to enter the play area.',
    noShowExit: 'Left Without Staying (No Payment)',
    noShowConfirmTitle: 'Confirm free exit',
    noShowConfirmBody: 'This child did not stay in the playground. They will be checked out without collecting payment, and the visit will be recorded as "Left Without Staying – No Payment". Continue?',
    noShowConfirmAction: 'Check Out Without Payment',
    noShowDone: 'Checked out without payment (no-show)',
    noShowStatus: 'Left Without Staying – No Payment',
    managePayment: 'Manage Payment',
    changeAmount: 'Change Amount',
    changeType: 'Change Payment Method',
    refundFull: 'Refund',
    awaitingApproval: 'Awaiting approval',
    sentForApproval: 'Sent for manager approval',
    paymentUpdated: 'Payment updated',
    newAmount: 'New amount',
    confirmRefundTitle: 'Confirm refund',
    confirmRefundBody: 'A full refund request will be created for this child. The change takes effect after manager approval. Continue?',
    paymentApprovals: 'Payment Approvals',
    approve: 'Approve',
    reject: 'Reject',
    noPendingApprovals: 'No pending approvals',
    submitRequest: 'Submit Request',
    childrenSelected: 'children selected',
    pleaseSelectChild: 'Please select at least one child to check in',
    failedToAddChild: 'Failed to add child',
    failedToCheckin: 'Failed to create check-in request',
    startOver: 'Start Over',
    submitCheckin: 'Submit Check-In Request',

    requestSubmitted: 'Request Submitted!',
    checkinRequestReceived: 'Your check-in request has been received',
    childrenCheckingIn: 'Children checking in:',
    nextSteps: 'Next Steps',
    step1: 'Proceed to the host desk',
    step2: 'Complete payment with the host',
    step3: 'Host will confirm check-in',
    step4: 'Your little ones can start playing!',
    importantNote: 'Please do not leave children unattended until check-in is confirmed by the host.',
    done: 'Done',

    hostLogin: 'Host Login',
    staffAccessOnly: 'Staff access only',
    adminLogin: 'Admin Login',
    adminAccessOnly: 'Admin access only',
    username: 'Username',
    enterUsername: 'Enter username',
    password: 'Password',
    enterPassword: 'Enter password',
    login: 'Login',
    contactManagement: 'Contact management if you need access',
    pleaseEnterCredentials: 'Please enter username and password',
    invalidCredentials: 'Invalid credentials',

    dashboard: 'Dashboard',
    kidsInside: 'Kids Inside',
    pending: 'Pending',
    inside: 'Inside',
    search: 'Search',
    noPendingCheckins: 'No Pending Check-ins',
    allCaughtUp: 'All caught up!',
    noKidsInside: 'No Kids Inside',
    playgroundEmpty: 'The playground is empty',
    confirmPaymentCheckin: 'Confirm Payment & Check-In',
    checkOut: 'Check Out',
    checkOutAll: 'Check Out All',
    checkedInAt: 'Checked in at',
    searchByPhoneOrName: 'Search by phone or name...',
    noResults: 'No Results',
    tryDifferentSearch: 'Try a different search term',
    totalVisits: 'Total visits',
    logout: 'Logout',
    error: 'Error',
    failedToConfirm: 'Failed to confirm check-in',
    failedToCheckout: 'Failed to check out',
    searchFailed: 'Search failed',
    submitted: 'Submitted',

    hours: 'h',
    minutes: 'm',

    language: 'Language',
    turkish: 'Türkçe',
    english: 'English',

    paymentAmount: 'Payment Amount',
    paymentType: 'Payment Type',
    selectAmount: 'Select amount',
    selectPaymentType: 'Select payment type',
    cash: 'Cash',
    card: 'Card',
    other: 'Other',
    loyaltyDiscount: 'Loyalty Discount',
    loyalty_discount: 'Loyalty Discount',
    otherAmount: 'Other Amount',
    removeCheckin: 'Remove Check-in',
    removeCheckinConfirm: 'Are you sure you want to remove this pending check-in request? This cannot be undone.',
    remove: 'Remove',
    checkinRemoved: 'Pending check-in removed',
    refund: 'Refund',
    refundPayment: 'Refund Payment',
    refundAmount: 'Refund Amount',
    refundHint: 'You can change the amount for a partial refund',
    refunded: 'Refunded',
    paid: 'Paid',
    paymentRefunded: 'Payment refunded',
    invalidRefund: 'Enter a valid amount',
    totalRefunds: 'Total Refunds',
    notes: 'Notes',
    notesPlaceholder: 'Add an optional note...',
    monthsUnit: 'mo',
    yearsUnit: 'yr',
    youngKidWarningTitle: 'Age Notice',
    youngKidWarning: 'Our area is suitable for children in the 2–6 age group. Children under 2 years old must use the area with parental support.',
    paymentRequired: 'Payment Required',
    skipPayment: 'Check In Without Payment',
    confirmWithPayment: 'Confirm with Payment',
    collectPayment: 'Collect Payment',
    paymentCollected: 'Payment Collected',
    unpaid: 'Unpaid',
    tl: '₺',

    pause: 'Pause',
    resume: 'Resume',
    onBreak: 'On Break',
    paused: 'Paused',

    statsTab: 'Stats',
    todaysSummary: "Today's Summary",
    summary: 'Summary',
    showingStatsFor: 'Showing date',
    today: 'Today',
    duration: 'Duration',
    childrenDetails: 'Children Details',
    totalCheckins: 'Total Check-ins',
    totalCheckouts: 'Total Check-outs',
    totalRevenue: 'Total Revenue',
    unpaidVisits: 'Unpaid',
    avgDuration: 'Avg. Duration',
    paymentBreakdown: 'Payment Breakdown',
    otherPayment: 'Other',
    todaysChildren: "Today's Children",
    statusActive: 'Inside',
    statusCheckedOut: 'Checked Out',
    statusPending: 'Pending',
    statusPaused: 'On Break',
    noVisitsToday: 'No visits today yet',
    min: 'min',

    kioskQR: 'Kiosk QR Code',
    qrTitle: 'Welcome to the Playground!',
    qrInstruction: 'Scan the QR code with your phone to check in',
    qrStep1: 'Open your phone camera',
    qrStep2: 'Scan the QR code',
    qrStep3: 'Register your children',
    qrPoweredBy: 'Little Friends Coffee & Play',

    admin: 'Admin',
    adminDashboard: 'Admin Dashboard',
    adminSubtitle: 'Business stats & marketing',
    backToHost: 'Back to Dashboard',
    overview: 'Overview',
    bookkeeping: 'Bookkeeping',
    birthdays: 'Birthdays',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    checkinsMetric: 'Check-ins',
    childrenMetric: 'Children',
    revenueMetric: 'Revenue',
    avgTransaction: 'Avg. Transaction',
    transactionsMetric: 'Transactions',
    downloadCsv: 'Download CSV',
    bookkeepingCsv: 'Bookkeeping CSV',
    bookkeepingDesc: 'Download visit & payment records by period.',
    customRange: 'Custom Date Range',
    startDate: 'Start',
    endDate: 'End',
    downloadRange: 'Download Range (CSV)',
    selectDates: 'Please select a start and end date',
    apply: 'Show',
    exportBirthdayList: 'Export Birthday List (CSV)',
    thisMonth: 'This Month',
    nextMonth: 'Next Month',
    next30: 'Next 30 Days',
    next60: 'Next 60 Days',
    allBirthdays: 'All',
    deleteEvent: 'Delete Event',
    deleteEventConfirm: 'This event will be permanently deleted and removed from both the List and Calendar views. Continue?',
    eventDeleted: 'Event deleted',
    selectMonth: 'Select Month',
    childFirstName: 'Child First Name',
    birthday: 'Birthday',
    turningAge: 'Turning Age',
    guardianName: 'Parent/Guardian',
    email: 'Email',
    phone: 'Phone',
    lastVisit: 'Last Visit',
    lastVisitRange: 'Last Visit Date',
    clearRange: 'Clear',
    readFullText: 'Read full text',
    consentTitle: 'Consents',
    consentOptionalHint: 'These consents are optional. You can complete your child\'s check-in without giving consent.',
    colMarketingConsent: 'Marketing Data Consent',
    colMarketingConsentDate: 'Marketing Consent Date',
    colCommConsent: 'Commercial Message Consent',
    colCommConsentDate: 'Commercial Consent Date',
    consentYes: 'Yes',
    consentNo: 'No',
    consentNotCollected: 'Not Collected',
    eligibleOnly: 'Marketing-eligible only',
    events: 'Events',
    eventsList: 'List',
    eventsCalendar: 'Calendar',
    status: 'Status',
    allStatuses: 'All Statuses',
    sortBy: 'Sort by',
    sortSubmission: 'Submission Date',
    sortRequestedDate: 'Requested Date',
    requests: 'requests',
    noEvents: 'No event requests yet',
    parentName: 'Parent Name',
    kids: 'Kids',
    adults: 'Adults',
    priceTL: 'Price (TL)',
    priceNotSet: 'No price set',
    statusNew: 'New',
    statusOfferSent: 'Offer Sent',
    statusConfirmed: 'Confirmed',
    statusCompleted: 'Completed',
    statusCancelled: 'Cancelled',
    calendarHint: 'Confirmed reservations are shown on their agreed date. Click for details.',
    mon: 'Mon', tue: 'Tue', wed: 'Wed', thu: 'Thu', fri: 'Fri', sat: 'Sat', sun: 'Sun',
    originalDate: 'Requested Date',
    originalTime: 'Requested Time',
    submittedOn: 'Submitted On',
    agreedDate: 'Agreed Date',
    agreedTime: 'Agreed Time',
    depositReceived: 'Down Payment Received',
    depositAmount: 'Deposit Amount (TL)',
    internalNotes: 'Internal Notes',
    saveChanges: 'Save Changes',
    savedSuccessfully: 'Saved successfully',
    childAge: "Child's Age",
    requestedDate: 'Requested Date',
    selectTime: 'Select time',
    birthdayTitle: 'Celebrate Your Birthday at Little Friends!',
    birthdaySubtitle: 'Planning a special birthday celebration? Share your preferred date and party details, and our team will contact you to discuss availability and arrangements.',
    parentInfo: 'Parent Information',
    childInfo: 'Child Information',
    conceptBreakfast: 'Birthday Breakfast',
    conceptTea: 'Birthday Tea Party',
    addEvent: '+ Add Event',
    createEvent: 'Create Event',
    partyDetails: 'Party Details',
    preferredTime: 'Preferred Time',
    altDate: 'Alternative Date',
    altTime: 'Alternative Time',
    estChildren: 'Estimated Number of Children',
    estAdults: 'Estimated Number of Adults',
    specialRequests: 'Special Requests / Additional Notes',
    sendBirthdayRequest: 'Send Birthday Request',
    fillRequiredFields: 'Please fill in the required fields',
    dateCannotBePast: 'Date cannot be in the past',
    thankYou: 'Thank you!',
    birthdaySuccessMsg: "We've received your birthday request. Our team will review your details and contact you shortly to discuss availability and arrangements.",
    submitAnother: 'Submit Another Request',
    noBirthdays: 'No birthdays in this period',
    emailNotCollected: 'Email address is not collected yet. Marketing and commercial-message consents are recorded at check-in.',
    january: 'January', february: 'February', march: 'March', april: 'April',
    may: 'May', june: 'June', july: 'July', august: 'August',
    september: 'September', october: 'October', november: 'November', december: 'December',
  },
};
